import { useEffect, useRef, useState } from "react";

export function useTextOverflow(label: string) {
	const textRef = useRef<HTMLDivElement>(null);
	const [isOverflowing, setIsOverflowing] = useState(false);

	// biome-ignore lint/correctness/useExhaustiveDependencies: don't want to change function of code right now
	useEffect(() => {
		const element = textRef.current;
		if (element) {
			setIsOverflowing(element.scrollWidth > element.clientWidth);
		}
	}, [label]);

	return { textRef, isOverflowing };
}
